import { render, staticRenderFns } from "./AppSocialShare.vue?vue&type=template&id=048bdaa4&"
import script from "./AppSocialShare.vue?vue&type=script&lang=js&"
export * from "./AppSocialShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports